<template>
  <tr class="bg-gray-50 hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm">
    <td
      class="py-3 text-left pl-3"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.billNumber') + ': ' + tradeItem.billNumber + ', ' + $t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.tradeItemName') + ': ' + tradeItem.name"
    >
      <div class="flex items-start space-x-2">
        <span class="font-semibold text-gray-900">{{ tradeItem.billNumber }}</span>

        <p class="w-60 text-gray-700">
          {{ tradeItem.name }}
        </p>
      </div>
    </td>

    <td
      class="pr-3 text-sm"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.budgetAmount') + ': ' + australianCurrency(tradeItem.budget)"
    >
      {{ australianCurrency(tradeItem.budget) }}
    </td>

    <template v-if="claim.capture_claim_amount">
      <td
        v-if="!falsey(tradeItemCost?.current_claim) && !typingClaim && canEditClaim"
        :class="{ 'cursor-pointer': canEditClaim }"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.currentClaim') + ': ' + (!falsey(tradeItemCost?.current_claim) ? australianCurrency(tradeItemCost.current_claim) : '')"
        @click="typeClaim"
      >
        <div class="group flex items-center justify-end">
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="group-hover:visible btn-icon-red h-4 w-4 inline-block invisible transition-all duration-150"
            :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.removeClaim')"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>

          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 v-if="canEditClaim"
           
            class="group-hover:visible btn-icon-blue h-4 w-4 inline-block invisible transition-all duration-150"
            :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editClaim')">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          {{ !falsey(tradeItemCost?.current_claim) ? australianCurrency(tradeItemCost.current_claim) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditClaim"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.currentClaim') + ': ' + $t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editClaim')"
      >
        <div class="">
          <AppCurrencyInput
            ref="claimInput"
            v-model.number="costForm.form.current_claim"
            name="current_claim"
            type="number"
            min="1"
            class="w-20 h-6 ml-auto form-input"
            :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editClaim')"
            @blur="stopTypingClaim"
            @keyup.enter="stopTypingClaim"
            @keyup.esc="typingClaim = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.currentClaim') + ': ' + (!falsey(tradeItemCost?.current_claim) ? australianCurrency(tradeItemCost.current_claim) : '')"
      >
        {{ !falsey(tradeItemCost?.current_claim) ? australianCurrency(tradeItemCost.current_claim) : '' }}
      </td>
    </template>

    <td
      v-if="!falsey(tradeItemCost?.current_certified) && !typingCertified && canEditCertified"
      :class="{ 'cursor-pointer': canEditCertified }"
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.currentCertified') + ': ' + (!falsey(tradeItemCost?.current_certified) ? australianCurrency(tradeItemCost.current_certified) : '')"
      @click="typeCertified"
    >
      <div class="group flex items-center justify-end">
        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="group-hover:visible btn-icon-red h-4 w-4 inline-block invisible transition-all duration-150"
          :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.removeCertified')"
          @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>

        <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 v-if="canEditCertified"
         
          class="group-hover:visible btn-icon-blue h-4 w-4 inline-block invisible transition-all duration-150"
          :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editCertified')">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        {{ !falsey(tradeItemCost?.current_certified) ? australianCurrency(tradeItemCost.current_certified) : '' }}
      </div>
    </td>

    <td
      v-else-if="canEditCertified"
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.currentCertified') + ': ' + $t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editCertified')"
    >
      <div class="">
        <AppCurrencyInput
          ref="certifiedInput"
          v-model.number="costForm.form.current_certified"
          name="current_certified"
          type="number"
          min="1"
          class="w-20 h-6 ml-auto form-input"
          :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editCertified')"
          @blur="stopTypingCertified"
          @keyup.enter="stopTypingCertified"
          @keyup.esc="typingCertified = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.currentCertified') + ': ' + (!falsey(tradeItemCost?.current_certified) ? australianCurrency(tradeItemCost.current_certified) : '')"
    >
      {{ !falsey(tradeItemCost?.current_certified) ? australianCurrency(tradeItemCost.current_certified) : '' }}
    </td>

    <td
      v-if="claim.capture_claim_amount"
      class="group bg-green-200/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 && varianceComment?.body ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.varianceAmount') + ': ' + (hasVariance ? australianCurrency(variance) : '') + (hasVariance && variance !== 0 && varianceComment?.body ? ', ' + $t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.varianceTooltip') + ': ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showCommentButton"
          type="button"
          class="btn-icon group-hover:visible btn-icon-default invisible mr-1 shrink-0"
          aria-label="Edit variance comment"
          @click.stop="editVarianceComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ hasVariance ? australianCurrency(variance) : '' }}
        </div>
      </div>
    </td>

    <td
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.previousAmount') + ': ' + australianCurrency(tradeItem.previous(claim))"
    >
      {{ australianCurrency(tradeItem.previous(claim)) }}
    </td>

    <td
      class="bg-green-200/50 pr-3"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.cumulativeAmount') + ': ' + australianCurrency(tradeItem.previous(claim) + (tradeItemCost?.current_certified || 0))"
    >
      {{ australianCurrency(tradeItem.previous(claim) + (tradeItemCost?.current_certified || 0)) }}
    </td>

    <template v-if="claim.capture_claim_amount">
      <td
        v-if="!falsey(tradeItemCost?.current_claim) && !typingClaim && canEditClaim"
        :class="{ 'cursor-pointer': canEditClaim }"
        class="bg-blue-300/50"
        :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.claimPercentage') + ': ' + (!falsey(tradeItemCost?.current_claim) ? `${australianNumber((tradeItemCost.current_claim / tradeItem.budget) * 100)}%` : '')"
        @click="typeClaimPercent"
      >
        <div class="group flex items-center justify-end">
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="group-hover:visible btn-icon-red h-4 w-4 inline-block invisible transition-all duration-150"
            :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.removeClaim')"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>

          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 v-if="canEditClaim"
           
            class="group-hover:visible btn-icon-blue h-4 w-4 inline-block invisible transition-all duration-150"
            :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editClaim')">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          {{ !falsey(tradeItemCost?.current_claim) ? `${australianNumber((tradeItemCost.current_claim / tradeItem.budget) * 100)}%` : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditClaim"
        class="bg-blue-300/50"
        :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.claimPercentage') + ': ' + $t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editClaim')"
      >
        <div class="">
          <AppInput
            ref="claimPercentInput"
            v-model.number="currentClaimPercent"
            name="current_claim_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editClaim')"
            @blur="stopTypingClaim"
            @keyup.enter="stopTypingClaim"
            @keyup.esc="typingClaim = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-300/50"
        :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.claimPercentage') + ': ' + (!falsey(tradeItemCost?.current_claim) ? `${australianNumber((tradeItemCost.current_claim / tradeItem.budget) * 100)}%` : '')"
      >
        {{ !falsey(tradeItemCost?.current_claim) ? `${australianNumber((tradeItemCost.current_claim / tradeItem.budget) * 100)}%` : '' }}
      </td>
    </template>

    <td
      v-if="!falsey(tradeItemCost?.current_certified) && !typingCertified && canEditCertified"
      :class="{ 'cursor-pointer': canEditCertified }"
      class="bg-blue-300/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.certifiedPercentage') + ': ' + (!falsey(tradeItemCost?.current_certified) ? `${australianNumber((tradeItemCost.current_certified / tradeItem.budget) * 100)}%` : '')"
      @click="typeCertifiedPercent"
    >
      <div class="group flex items-center justify-end">
        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="group-hover:visible btn-icon-red h-4 w-4 inline-block invisible transition-all duration-150"
          :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.removeCertified')"
          @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>

        <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 v-if="canEditCertified"
         
          class="group-hover:visible btn-icon-blue h-4 w-4 inline-block invisible transition-all duration-150"
          :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editCertified')">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        {{ !falsey(tradeItemCost?.current_certified) ? `${australianNumber((tradeItemCost.current_certified / tradeItem.budget) * 100)}%` : '' }}
      </div>
    </td>

    <td
      v-else-if="canEditCertified"
      class="bg-blue-300/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.certifiedPercentage') + ': ' + $t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editCertified')"
    >
      <div class="">
        <AppInput
          ref="certifiedPercentInput"
          v-model.number="currentCertifiedPercent"
          name="current_certified_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.editCertified')"
          @blur="stopTypingCertified"
          @keyup.enter="stopTypingCertified"
          @keyup.esc="typingCertified = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-blue-300/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.certifiedPercentage') + ': ' + (!falsey(tradeItemCost?.current_certified) ? `${australianNumber((tradeItemCost.current_certified / tradeItem.budget) * 100)}%` : '')"
    >
      {{ !falsey(tradeItemCost?.current_certified) ? `${australianNumber((tradeItemCost.current_certified / tradeItem.budget) * 100)}%` : '' }}
    </td>

    <td
      class="bg-blue-300/50"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.previousPercentage') + ': ' + australianNumber((tradeItem.previous(claim) / tradeItem.budget) * 100) + '%'"
    >
      {{ australianNumber((tradeItem.previous(claim) / tradeItem.budget) * 100) }}%
    </td>

    <td
      class="bg-blue-300/50 pr-3"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.cumulativePercentage') + ': ' + australianNumber(((tradeItem.previous(claim) + (tradeItemCost?.current_certified || 0)) / tradeItem.budget) * 100) + '%'"
    >
      {{ australianNumber(((tradeItem.previous(claim) + (tradeItemCost?.current_certified || 0)) / tradeItem.budget) * 100) }}%
    </td>

    <td
      class="pr-3"
      :aria-label="$t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.accessibility.costToComplete') + ': ' + australianCurrency(Math.abs(tradeItem.budget - tradeItem.previous(claim) - (tradeItemCost?.current_certified || 0)))"
    >
      {{ australianCurrency(Math.abs(tradeItem.budget - tradeItem.previous(claim) - (tradeItemCost?.current_certified || 0))) }}
    </td>
  </tr>
</template>

<script setup lang="ts">
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, australianNumber, falsey, isNumber, roundDecimals } from '@/helpers';
import { t } from '@/i18n';
import Claim, { ClaimStatus } from '@/models/Claim';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { useTradeItemCostsStore } from '@/store/tradeItemCosts';
import Swal from 'sweetalert2';
import { nextTick, ref, watch } from 'vue';
import { computed } from 'vue';
import { toast } from 'vue3-toastify';

const props = defineProps<{
  trade: Trade;
  claim: Claim;
  tradeItem: TradeItem;
}>();

const tradeItemCostsStore = useTradeItemCostsStore();

const tradeItemCost = computed(() => {
  return tradeItemCostsStore.models.with('comments')
    .where('trade_item_id', props.tradeItem.id)
    .where('claim_id', props.claim.id)
    .first();
});

const canEditCertified = computed(() => {
  return props.claim.status === ClaimStatus.draft;
});

const typingCertified = ref(falsey(tradeItemCost.value?.current_certified));
const certifiedInput = ref();
const certifiedPercentInput = ref();

const typeCertified = () => {
  if(canEditCertified.value) {
    typingCertified.value = true;

    nextTick(() => {
      certifiedInput.value?.focusInput();
    });
  }
};

const typeCertifiedPercent = () => {
  if(canEditCertified.value) {
    typingCertified.value = true;

    nextTick(() => {
      certifiedPercentInput.value?.focusInput();
    });
  }
};

const canEditClaim = computed(() => {
  return props.claim.status === ClaimStatus.draft;
});

const typingClaim = ref(falsey(tradeItemCost.value?.current_claim));
const claimInput = ref();
const claimPercentInput = ref();

const typeClaim = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const costForm = useFormData({
  current_certified: undefined,
  current_claim: undefined,
  comment: undefined,
});

const currentCertifiedPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_certified / props.tradeItem.budget) * 100) || undefined;
  },

  set(value) {
    costForm.form.current_certified = roundDecimals((value / 100) * props.tradeItem.budget);
  },
});

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.tradeItem.budget) * 100) || undefined;
  },

  set(value) {
    costForm.form.current_claim = roundDecimals((value / 100) * props.tradeItem.budget);
  },
});

watch(tradeItemCost, (newValue) => {
  if(newValue) {
    costForm.setData(newValue);
  }
}, { immediate: true });

const storeTradeItemCostAction = useStoreApiAction(tradeItemCostsStore.createTradeItemCost);
const updateTradeItemCostAction = useStoreApiAction(tradeItemCostsStore.updateTradeItemCost);
const updateCommentAction = useStoreApiAction(tradeItemCostsStore.updateComment);
const deleteTradeItemCostAction = useStoreApiAction(tradeItemCostsStore.deleteTradeItemCost);

const stopTypingClaim = async () => {
  // if claim not set and the cost does not exist, then don't continue
  if(
    (falsey(costForm.form.current_claim) && !tradeItemCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  // if both have been cleared out, delete the cost
  if(falsey(costForm.form.current_claim) && tradeItemCost.value && falsey(tradeItemCost.value.current_certified)) {
    deleteTradeItemCostAction.request(tradeItemCost.value.id).then(() => {
      typingClaim.value = true;
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
      });

      typingClaim.value = false;
    });
  } else if(tradeItemCost.value) {
    // updating existing cost current_claim
    costForm.resetData(['comment']);

    // if current certified is set and incoming new claim != current certified, require comment
    if(
      !falsey(tradeItemCost.value.current_certified) &&
      costForm.form.current_claim !== tradeItemCost.value.current_certified
    ) {
      // const comment = !tradeComment ?
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.reasonForAdjustment'),
        text: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.varianceReasonPrompt'),
        input: 'text',
      });
      // :
      // undefined;

      costForm.form.comment = comment?.value;

      // TODO: 10/27/23 maybe stop prompting to apply to trade

      // if(!tradeComment) {
      //   await Swal.fire({
      //     icon: 'question',
      //     title: 'Apply Comment to Trade?',
      //     showConfirmButton: true,
      //     confirmButtonText: 'Yes',
      //     showDenyButton: true,
      //   }).then((result) => {
      //     if(result.isConfirmed) {
      //       costForm.form.comment_trade_item = true;
      //     }
      //   });
      // }
    }

    updateTradeItemCostAction.request(tradeItemCost.value.id, {
      current_claim: costForm.form.current_claim,
      comment: costForm.form.comment,
    })
      .then((_tradeItemCost) => {
        if(falsey(tradeItemCost.value.current_claim)) {
          typingClaim.value = true;
        } else {
          typingClaim.value = false;
        }
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.invalidData'),
            text: error.data.message,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
          });
        }

        costForm.form.current_claim = tradeItemCost.value.current_claim;
        typingClaim.value = false;
      });
  } else {
    storeTradeItemCostAction.request(props.claim.id, props.tradeItem.id, costForm.form).then((_tradeItemCost) => {
      typingClaim.value = false;
    }).catch((error) => {
      console.log(error);

      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.invalidAmount'),
          text: error.data.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
        });
      }

      typingClaim.value = true;
    });
  }
};

const stopTypingCertified = async () => {
  if(
    (falsey(costForm.form.current_certified) && !tradeItemCost.value) ||
    !typingCertified.value
  ) {
    return;
  }

  if(falsey(costForm.form.current_certified) && tradeItemCost.value && falsey(tradeItemCost.value.current_claim)) {
    deleteTradeItemCostAction.request(tradeItemCost.value.id).then(() => {
      typingCertified.value = false;
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
      });

      typingCertified.value = true;
    });
  } else if(tradeItemCost.value) {
    costForm.resetData(['comment']);

    // if current claim is set and incoming certified is different, require comment
    if(
      !falsey(tradeItemCost.value.current_claim) &&
      costForm.form.current_certified !== tradeItemCost.value.current_claim
    ) {
      // const comment = !tradeComment ?
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.reasonForAdjustment'),
        text: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.varianceReasonPrompt'),
        input: 'text',
      });
      // :
      // undefined;

      costForm.form.comment = comment?.value;

      // TODO: 10/27/23 maybe stop prompting to apply to trade

      // if(!tradeComment) {
      //   await Swal.fire({
      //     icon: 'question',
      //     title: 'Apply Comment to Trade?',
      //     showConfirmButton: true,
      //     confirmButtonText: 'Yes',
      //     showDenyButton: true,
      //   }).then((result) => {
      //     if(result.isConfirmed) {
      //       costForm.form.comment_trade_item = true;
      //     }
      //   });
      // }
    }

    updateTradeItemCostAction.request(tradeItemCost.value.id, {
      current_certified: costForm.form.current_certified,
      comment: costForm.form.comment,
    })
      .then((_tradeItemCost) => {
        if(falsey(tradeItemCost.value?.current_certified)) {
          typingCertified.value = true;
        } else {
          typingCertified.value = false;
        }
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.invalidData'),
            text: error.data.message,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
          });
        }

        costForm.form.current_certified = tradeItemCost.value.current_certified;

        typingCertified.value = false;
      });
  } else {
    storeTradeItemCostAction.request(props.claim.id, props.tradeItem.id, costForm.form).then((tradeItemCost) => {
      console.log(tradeItemCost);
      typingCertified.value = false;
    }).catch((error) => {
      console.log(error);

      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.invalidAmount'),
          text: error.data.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
        });
      }

      typingCertified.value = true;
    });
  }
};

const deleteCost = () => {
  deleteTradeItemCostAction.request(tradeItemCost.value.id).then(() => {
    costForm.form.current_certified = undefined;
    costForm.form.current_claim = undefined;
    typingCertified.value = true;
    typingClaim.value = true;
  }).catch((_error) => {
    Swal.fire({
      icon: 'error',
      title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
    });
  });
};

const removeClaim = () => {
  if(falsey(tradeItemCost.value.current_certified)) {
    deleteCost();
  } else {
    updateTradeItemCostAction.request(tradeItemCost.value.id, { current_claim: undefined })
      .then((tradeItemCost) => {
        console.log(tradeItemCost);
        typingClaim.value = true;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.invalidAmount'),
            text: error.data.message,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
          });
        }

        costForm.form.current_claim = tradeItemCost.value.current_claim;
      });
  }
};

const removeCertified = () => {
  if(falsey(tradeItemCost.value.current_claim)) {
    deleteCost();
  } else {
    updateTradeItemCostAction.request(tradeItemCost.value.id, { current_certified: undefined })
      .then((tradeItemCost) => {
        console.log(tradeItemCost);
        typingCertified.value = true;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.invalidAmount'),
            text: error.data.message,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.IndirectProgressClaimsShow.TradeRowItem.message.somethingWentWrong'),
          });
        }

        costForm.form.current_certified = tradeItemCost.value.current_certified;
      });
  }
};

const varianceComment = computed(() => {
  return tradeItemCost.value?.comments[0];
});

const variance = computed(() => {
  return tradeItemCost.value?.current_claim - tradeItemCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(tradeItemCost.value?.current_claim) && !falsey(tradeItemCost.value?.current_certified);
});

const showCommentButton = computed(() => {
  return hasVariance.value && variance.value !== 0 && !!varianceComment.value && canEditCertified.value;
});

const editVarianceComment = () => {
  Swal.fire({
    icon: 'warning',
    title: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentTitle'),
    text: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentText'),
    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: 'Update',
  }).then((result) => {
    if(result.isConfirmed) {
      if(result.value) {
        updateCommentAction.request(tradeItemCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      }
    }
  });
};
</script>

<style scoped></style>
